import { IEnvironment } from '@environments/i-environment'

// noinspection JSUnusedGlobalSymbols
export const environment: IEnvironment = {
  name: 'prod',
  production: true,
  loggers: ['deprecated', 'hello', 'loader'],
}
